import clsx from "clsx"
import { routes } from "src/routes"
import { A } from "./A"
import { Icon } from "./Icon"

export type LogoProps = {
  className?: string
}

export const Logo = ({ className }: LogoProps) => {
  return (
    <A href={routes.home} title="Startseite" aria-label="Startseite" className="block w-35 rounded-lg pb-[2.5%]">
      <Icon
        name="logo_panorama"
        aria-label="Elvent Logo"
        className={clsx(className, "aspect-[88.26/16.66] size-full")}
      />
    </A>
  )
}
